/* azado Grillfest-Popup mit Minigame (4.11.2026, Kevin). Gewinn: unverbindliche Einladung zum azado Grillfest, dann E-Mail an Klaviyo (Liste Wt9Cd9, Double Opt-in).
   Zwei Spiele:
   "kugel": Glut faellt durch den Rost, nur das mittlere Fach gewinnt.
   "temp":  Kerntemperatur, Thermometer bei medium rare stoppen.
   Beide: drei Versuche, spaetestens der dritte gewinnt (Kevin).
   Test: Gruppe K (25 %) Kugelspiel, T (25 %) Kerntemperatur, B (50 %) nie ein Popup. Gruppe steht im Warenkorb-Attribut "Popup-Gruppe", damit Bestellungen vergleichbar sind.
   LIVE = true seit 4.11. (Kevin: «beide live»). Vorschau ohne Gruppe: ?grillfest=1 (Kugel) oder ?grillfest=2 (Kerntemperatur). Aus: LIVE auf false. */
(function () {
  "use strict";
  var LIVE = true;
  var GAME = "kugel";
  var LIST_ID = "Wt9Cd9", COMPANY = "Ru9KGZ", DELAY = 20000, PAUSE_DAYS = 14;
  var SLOTS = ["Niete", "Niete", "Grillfest", "Niete", "Niete"];
  var TRIES = 3;
  // Kevin 4.11.: hohe Gewinnchance, spätestens der 3. Wurf trifft. Zug zur Mitte je Wurf (sim. ca. 65 %, 80 %, 100 %)
  var STEER = [0.5, 0.8, 0.8], WIN = 2;
  // Kerntemperatur je Versuch: Start °C, °C pro Sekunde, Gewinnbereich, Selbststopp. Der 3. Versuch startet im Bereich und gewinnt immer.
  var HEAT = [
    { from: 30, speed: 7, lo: 52, hi: 57, auto: 80 },
    { from: 40, speed: 5, lo: 50, hi: 60, auto: 80 },
    { from: 50, speed: 2, lo: 50, hi: 56, auto: 56 }
  ];

  var pm = location.search.match(/[?&]grillfest=([12])(&|$)/), preview = !!pm;
  if (!LIVE && !preview) return;

  function ls(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  var group = ls("azGfGroup");
  if (group !== "K" && group !== "T" && group !== "B") {
    var rnd = Math.random(); group = rnd < 0.25 ? "K" : rnd < 0.5 ? "T" : "B"; ls("azGfGroup", group);
  }
  if (preview) group = pm[1] === "2" ? "T" : "K";
  GAME = group === "T" ? "temp" : "kugel";
  var TEMP = GAME === "temp", GAME_NAME = TEMP ? "Kerntemperatur" : "Kugelspiel";

  if (LIVE && !preview && !ss("azGfAttr")) {
    ss("azGfAttr", "1");
    try {
      fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: { "Popup-Gruppe": group === "B" ? "B ohne Popup" : "A " + GAME_NAME } }) });
    } catch (e) {}
  }
  if (group === "B") return;

  function blocked() {
    if (preview) return false;
    if (ls("azGfDone")) return true;
    var closed = +ls("azGfClosed") || 0;
    if (closed && Date.now() - closed < PAUSE_DAYS * 864e5) return true;
    if (/\/(cart|checkout|checkouts|account)(\/|$)|\/pages\/kontakt/.test(location.pathname)) return true;
    if (typeof window.azNoPopupSticky === "function" && window.azNoPopupSticky()) return true;
    if (document.documentElement.classList.contains("az-no-popup")) return true;
    if (document.querySelector(".az-quiz:not([hidden])")) return true;
    return false;
  }

  var CSS =
    ".az-gf{position:fixed;inset:0;z-index:310;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(12,12,11,.62);animation:azgfIn .25s ease both}" +
    ".az-gf[hidden]{display:none}" +
    ".az-gf__sheet{position:relative;width:min(420px,100%);max-height:calc(100dvh - 32px);overflow-y:auto;overscroll-behavior:contain;background:#1C1C1A;color:#F2EEE6;padding:28px 24px 24px;font-family:'Myriad Pro',Montserrat,Arial,sans-serif;animation:azgfUp .3s ease both}" +
    ".az-gf__close{position:absolute;top:4px;right:4px;width:44px;height:44px;border:0;border-radius:0;background:transparent;color:#F2EEE6;font-size:28px;line-height:1;cursor:pointer}" +
    ".az-gf__close:hover,.az-gf__close:focus-visible{background:#B2A185;color:#1C1C1A;outline:none}" +
    ".az-gf h2{margin:0 44px 10px 0;font-family:'Fenice Pro',Georgia,serif;font-style:italic;font-weight:400;font-size:clamp(28px,7vw,34px);line-height:1.05;letter-spacing:-.01em;color:#F2EEE6}" +
    ".az-gf p{margin:0;font-size:17px;line-height:1.45;color:#F2EEE6}" +
    ".az-gf__board{position:relative;margin:18px -4px 0;background:#141413}" +
    ".az-gf__board canvas{display:block;width:100%;height:auto;touch-action:manipulation}" +
    ".az-gf__btn{display:flex;align-items:center;justify-content:center;width:100%;min-height:52px;margin-top:14px;border:0;border-radius:0;background:#B2A185;color:#1C1C1A;font:inherit;font-size:17px;font-weight:700;cursor:pointer;transition:background .15s,transform .1s}" +
    ".az-gf__btn:hover,.az-gf__btn:focus-visible{background:#F2EEE6;outline:none}" +
    ".az-gf__btn:active{transform:scale(.98)}" +
    ".az-gf__btn[disabled]{opacity:.6;cursor:default}" +
    ".az-gf label{display:block;margin:18px 0 6px;font-size:16px;color:#F2EEE6}" +
    ".az-gf input{display:block;width:100%;box-sizing:border-box;height:52px;padding:0 14px;border:2px solid #3A3A36;border-radius:0;background:#262624;color:#F2EEE6;font:inherit;font-size:17px}" +
    ".az-gf input:focus{border-color:#B2A185;outline:none}" +
    ".az-gf__err{min-height:20px;margin-top:6px;font-size:15px;color:#FF9A8D}" +
    ".az-gf__fine{margin-top:12px!important;font-size:14px!important;color:#BDB7AC!important}" +
    ".az-gf__step[hidden]{display:none}" +
    ".az-gf__note{min-height:24px;margin-top:12px!important;font-size:17px!important;color:#FF9A8D!important}" +
    ".az-gf__note.is-win{color:#B2A185!important}" +
    ".az-gf__prize{margin-top:14px;padding:16px;background:#262624}" +
    ".az-gf__prize strong{display:block;font-family:'Fenice Pro',Georgia,serif;font-style:italic;font-weight:400;font-size:24px;line-height:1.1;color:#B2A185;margin-bottom:6px}" +
    "@keyframes azgfIn{from{opacity:0}to{opacity:1}}@keyframes azgfUp{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:none}}" +
    "@media (prefers-reduced-motion:reduce){.az-gf,.az-gf__sheet{animation:none}}";

  var root, sheet, canvas, ctx, slot = null, tries = 0, won = false, W = 0, H = 0, dpr = 1, pegs = [], ball = null, raf = 0, lastFocus = null;
  var temp = 30, heating = false, t0 = 0, result = "";
  var COPY = TEMP ? {
    t1: "Triff den Garpunkt", p1: "Feuer an, Thermometer läuft. Stopp bei medium rare und du bekommst eine unverbindliche Einladung zum azado Grillfest. Du hast drei Versuche.",
    go: "Grill anfeuern", again: "Nochmal anfeuern", one: "ein Versuch.", many: " Versuche."
  } : {
    t1: "Lass die Glut fallen", p1: "Triff das Fach in der Mitte und du bekommst eine unverbindliche Einladung zum azado Grillfest. Du hast drei Würfe.",
    go: "Kugel fallen lassen", again: "Nochmal werfen", one: "ein Wurf.", many: " Würfe."
  };

  function el(html) { var d = document.createElement("div"); d.innerHTML = html; return d.firstElementChild; }

  function build() {
    var st = document.createElement("style"); st.textContent = CSS; document.head.appendChild(st);
    root = el(
      '<div class="az-gf" role="dialog" aria-modal="true" aria-labelledby="az-gf-t1" hidden>' +
        '<div class="az-gf__sheet">' +
          '<button type="button" class="az-gf__close" aria-label="Schliessen">&times;</button>' +
          '<div class="az-gf__step" data-step="1">' +
            '<h2 id="az-gf-t1">' + COPY.t1 + '</h2>' +
            '<p>' + COPY.p1 + '</p>' +
            '<div class="az-gf__board"><canvas aria-hidden="true"></canvas></div>' +
            '<p class="az-gf__note" data-note aria-live="polite"></p>' +
            '<button type="button" class="az-gf__btn" data-drop>' + COPY.go + '</button>' +
          '</div>' +
          '<div class="az-gf__step" data-step="2" hidden>' +
            '<h2 id="az-gf-t2" data-t2>Du bist eingeladen</h2>' +
            '<div class="az-gf__prize" data-prizebox><strong>azado Grillfest</strong><p>Deine unverbindliche Einladung: Feuer, Fleisch und Freunde. Wir melden uns, sobald das nächste Grillfest steht.</p></div>' +
            '<p data-lose hidden>Melde dich trotzdem an: Rezepte, Grilltricks und unsere Aktionen, bevor sie online sind. Beim nächsten Spiel hast du wieder drei Würfe.</p>' +
            '<form novalidate>' +
              '<label for="az-gf-mail" data-label>Wohin dürfen wir die Einladung schicken?</label>' +
              '<input id="az-gf-mail" type="email" name="email" autocomplete="email" inputmode="email" placeholder="name@beispiel.ch" aria-describedby="az-gf-err az-gf-fine" required>' +
              '<div class="az-gf__err" id="az-gf-err" role="alert"></div>' +
              '<button type="submit" class="az-gf__btn" data-submit>Einladung sichern</button>' +
              '<p class="az-gf__fine" id="az-gf-fine">Damit meldest du dich für den azado Newsletter an. Abmelden geht jederzeit mit einem Klick.</p>' +
            '</form>' +
          '</div>' +
          '<div class="az-gf__step" data-step="3" hidden>' +
            '<h2 id="az-gf-t3">Fast geschafft</h2>' +
            '<p data-thanks>Wir haben dir eine Mail geschickt. Bestätige deine Adresse, dann kommt deine unverbindliche Einladung, sobald das nächste azado Grillfest steht.</p>' +
            '<button type="button" class="az-gf__btn" data-done>Weiter stöbern</button>' +
          '</div>' +
        '</div>' +
      '</div>');
    document.body.appendChild(root);
    sheet = root.querySelector(".az-gf__sheet");
    canvas = root.querySelector("canvas");
    ctx = canvas.getContext("2d");
    root.querySelector(".az-gf__close").addEventListener("click", close);
    root.querySelector("[data-done]").addEventListener("click", function () { hide(); });
    root.querySelector("[data-drop]").addEventListener("click", TEMP ? heat : drop);
    if (TEMP) canvas.addEventListener("click", function () { if (heating) heat(); });
    root.querySelector("form").addEventListener("submit", submit);
    root.querySelector("input").addEventListener("input", function () { root.querySelector(".az-gf__err").textContent = ""; });
    root.addEventListener("click", function (e) { if (e.target === root) close(); });
    root.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { close(); return; }
      if (e.key !== "Tab") return;
      var f = [].filter.call(sheet.querySelectorAll("button,input"), function (n) { return n.offsetParent !== null && !n.disabled; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    window.addEventListener("resize", function () { if (!root.hidden) { layout(); paint(); } });
  }

  function layout() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = canvas.parentNode.clientWidth; H = Math.round(W * 0.82);
    canvas.width = W * dpr; canvas.height = H * dpr; canvas.style.height = H + "px";
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    pegs = [];
    var rows = 6, gap = W / 7, top = H * 0.12, step = (H * 0.62) / rows;
    for (var r = 0; r < rows; r++) {
      var n = r % 2 ? 6 : 7, off = r % 2 ? gap : gap / 2;
      for (var i = 0; i < n; i++) pegs.push({ x: off + i * gap, y: top + r * step });
    }
  }

  function paint() {
    if (TEMP) { paintTemp(); return; }
    var sw = W / SLOTS.length, fy = H - 46;
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#141413"; ctx.fillRect(0, 0, W, H);
    for (var i = 0; i < SLOTS.length; i++) {
      var hit = slot !== null && i === slot, fest = SLOTS[i] === "Grillfest";
      ctx.fillStyle = fest ? (hit ? "#E8551F" : "#B2A185") : (hit ? "#3A3A36" : "#232321");
      ctx.fillRect(i * sw + 2, fy, sw - 4, 46);
      ctx.fillStyle = fest ? "#1C1C1A" : (hit ? "#FF9A8D" : "#8C877D");
      ctx.font = Math.min(16, Math.max(12, Math.round(sw * 0.2))) + "px 'Myriad Pro',Montserrat,Arial,sans-serif";
      ctx.textAlign = "center"; ctx.textBaseline = "middle";
      ctx.fillText(SLOTS[i], i * sw + sw / 2, fy + 23);
    }
    ctx.fillStyle = "#8C877D";
    for (var j = 1; j < SLOTS.length; j++) ctx.fillRect(j * sw - 2, fy - 18, 4, 64);
    for (var k = 0; k < pegs.length; k++) {
      ctx.beginPath(); ctx.arc(pegs[k].x, pegs[k].y, Math.max(3, W / 110), 0, 6.3); ctx.fillStyle = "#B2A185"; ctx.fill();
    }
    if (ball) {
      ctx.beginPath(); ctx.arc(ball.x, ball.y, ball.r, 0, 6.3); ctx.fillStyle = "#E8551F"; ctx.fill();
      ctx.beginPath(); ctx.arc(ball.x - ball.r * 0.25, ball.y - ball.r * 0.25, ball.r * 0.45, 0, 6.3); ctx.fillStyle = "#FFB15C"; ctx.fill();
    }
  }

  function drop() {
    var btn = root.querySelector("[data-drop]");
    if (btn.disabled) return;
    btn.disabled = true; btn.textContent = "Die Glut fällt";
    slot = null; root.querySelector("[data-note]").textContent = "";
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      finish(tries === TRIES - 1 || Math.random() < [0.65, 0.8][tries] ? WIN : [0, 1, 3, 4][Math.floor(Math.random() * 4)]); return;
    }
    var k = STEER[tries] || STEER[STEER.length - 1], last = tries === TRIES - 1;
    var r = Math.max(6, W / 46);
    ball = { x: W / 2 + (Math.random() - 0.5) * W * 0.12, y: r + 2, vx: (Math.random() - 0.5) * 1.4, vy: 0, r: r };
    var pr = Math.max(3, W / 110), g = H / 1200, floor = H - 46 - r, vmax = H / 110, lastRow = H * 0.12 + H * 0.62 * 5 / 6;
    (function tick() {
      ball.vy = Math.min(vmax, ball.vy + g * 0.3); ball.vx += (W / 2 - ball.x) * k / W;
      ball.x += ball.vx; ball.y += ball.vy; ball.vx *= 0.99;
      if (last && ball.y > lastRow) { ball.x += (W / 2 - ball.x) * 0.12; ball.vx *= 0.7; }
      for (var i = 0; i < pegs.length; i++) {
        var p = pegs[i], dx = ball.x - p.x, dy = ball.y - p.y, d = Math.sqrt(dx * dx + dy * dy), m = ball.r + pr;
        if (d < m && d > 0) {
          var nx = dx / d, ny = dy / d; ball.x = p.x + nx * m; ball.y = p.y + ny * m;
          var v = ball.vx * nx + ball.vy * ny; ball.vx -= 1.55 * v * nx; ball.vy -= 1.55 * v * ny;
          ball.vx += (Math.random() - 0.5) * 0.7;
        }
      }
      if (ball.x < ball.r) { ball.x = ball.r; ball.vx = Math.abs(ball.vx) * 0.5; }
      if (ball.x > W - ball.r) { ball.x = W - ball.r; ball.vx = -Math.abs(ball.vx) * 0.5; }
      paint();
      if (ball.y < floor) raf = requestAnimationFrame(tick);
      else finish(Math.min(SLOTS.length - 1, Math.max(0, Math.floor(ball.x / (W / SLOTS.length)))));
    })();
  }

  // Kerntemperatur: Garstufe und Fleischfarbe (Rind, Kern)
  function stufe(t) { return t < 46 ? "roh" : t < 52 ? "rare" : t <= 57 ? "medium rare" : t < 63 ? "medium" : t < 68 ? "medium well" : "well done"; }
  var MEAT = [[30, [142, 27, 50]], [48, [194, 50, 74]], [55, [217, 96, 110]], [60, [207, 138, 132]], [68, [169, 135, 122]], [80, [140, 112, 98]]];
  function meat(t) {
    for (var i = 1; i < MEAT.length; i++) if (t <= MEAT[i][0] || i === MEAT.length - 1) {
      var a = MEAT[i - 1], b = MEAT[i], f = Math.max(0, Math.min(1, (t - a[0]) / (b[0] - a[0])));
      return "rgb(" + [0, 1, 2].map(function (k) { return Math.round(a[1][k] + (b[1][k] - a[1][k]) * f); }).join(",") + ")";
    }
  }
  function paintTemp() {
    var h = HEAT[Math.min(tries, HEAT.length - 1)], t = Math.round(temp), cx = W / 2;
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#141413"; ctx.fillRect(0, 0, W, H);
    // Steak im Anschnitt: Kruste, graues Band, rosa Kern, der mit der Hitze schrumpft
    var cy = H * 0.3, rx = W * 0.36, ry = H * 0.19, done = Math.max(0, Math.min(1, (temp - 30) / 50));
    ctx.beginPath(); ctx.ellipse(cx, cy, rx, ry, 0, 0, 6.3); ctx.fillStyle = "#3B2418"; ctx.fill();
    ctx.beginPath(); ctx.ellipse(cx, cy, rx * 0.93, ry * 0.88, 0, 0, 6.3); ctx.fillStyle = "#9C7E6E"; ctx.fill();
    ctx.beginPath(); ctx.ellipse(cx, cy, rx * 0.93 * (1 - 0.55 * done), ry * 0.88 * (1 - 0.55 * done), 0, 0, 6.3); ctx.fillStyle = meat(temp); ctx.fill();
    // Anzeige
    ctx.textAlign = "center"; ctx.textBaseline = "alphabetic";
    ctx.fillStyle = "#F2EEE6"; ctx.font = "italic " + Math.round(Math.min(46, W * 0.13)) + "px 'Fenice Pro',Georgia,serif";
    ctx.fillText(t + " °C", cx, H * 0.62);
    ctx.fillStyle = "#BDB7AC"; ctx.font = "16px 'Myriad Pro',Montserrat,Arial,sans-serif";
    ctx.fillText(stufe(t), cx, H * 0.62 + 22);
    // Thermometer: Skala 30 bis 80 °C, Gewinnbereich gold
    var bx = 16, bw = W - 32, by = H * 0.81, bh = 14, x = function (v) { return bx + bw * (Math.max(30, Math.min(80, v)) - 30) / 50; };
    ctx.fillStyle = "#262624"; ctx.fillRect(bx, by, bw, bh);
    ctx.fillStyle = "#B2A185"; ctx.fillRect(x(h.lo), by - 6, x(h.hi) - x(h.lo), bh + 12);
    ctx.fillStyle = "#E8551F"; ctx.fillRect(bx, by + 3, x(temp) - bx, bh - 6);
    ctx.fillStyle = "#F2EEE6"; ctx.fillRect(x(temp) - 1.5, by - 8, 3, bh + 16);
    ctx.fillStyle = "#8C877D"; ctx.font = "13px 'Myriad Pro',Montserrat,Arial,sans-serif";
    for (var v = 30; v <= 80; v += 10) ctx.fillText(String(v), x(v), by + bh + 22);
  }

  function heat() {
    var btn = root.querySelector("[data-drop]"), note = root.querySelector("[data-note]"), h = HEAT[Math.min(tries, HEAT.length - 1)];
    if (!heating) {
      heating = true; t0 = performance.now(); temp = h.from;
      note.textContent = ""; note.classList.remove("is-win");
      btn.textContent = "Stopp"; btn.focus({ preventScroll: true });
      (function tick() {
        temp = Math.min(h.auto, h.from + (performance.now() - t0) / 1000 * h.speed);
        paint();
        if (temp >= h.auto) heat(); else raf = requestAnimationFrame(tick);
      })();
      return;
    }
    heating = false; cancelAnimationFrame(raf);
    temp = Math.min(h.auto, h.from + (performance.now() - t0) / 1000 * h.speed);
    var t = Math.round(temp); temp = t; paint();
    result = t + " °C";
    var hit = tries === TRIES - 1 || (t >= h.lo && t <= h.hi);
    if (hit) {
      btn.disabled = true;
      note.classList.add("is-win");
      outcome(true, t + " °C, " + stufe(t) + (t >= 52 && t <= 57 ? ". Perfekt." : ". Knapp, zählt."), 1400);
    } else {
      outcome(false, t + " °C, " + (t < h.lo ? (t < 46 ? "noch roh." : "erst " + stufe(t) + ".") : "schon " + stufe(t) + ".") + " ");
    }
  }

  function finish(i) {
    if (tries === TRIES - 1) i = WIN;
    slot = i; paint();
    result = SLOTS[i];
    outcome(SLOTS[i] === "Grillfest", SLOTS[i] === "Grillfest" ? "" : "Niete. ", 800);
  }

  function outcome(hit, msg, wait) {
    var q = function (s) { return root.querySelector(s); };
    if (hit) {
      if (msg) q("[data-note]").textContent = msg;
      won = true;
      q("[data-t2]").textContent = "Du bist eingeladen";
      q("[data-prizebox]").hidden = false; q("[data-lose]").hidden = true;
      q("[data-label]").textContent = "Wohin dürfen wir die Einladung schicken?";
      q("[data-submit]").textContent = "Einladung sichern";
      q("[data-thanks]").textContent = "Wir haben dir eine Mail geschickt. Bestätige deine Adresse, dann kommt deine unverbindliche Einladung, sobald das nächste azado Grillfest steht.";
    } else {
      tries++;
      if (tries < TRIES) {
        var left = TRIES - tries;
        q("[data-note]").textContent = msg + "Noch " + (left === 1 ? COPY.one : left + COPY.many);
        var b = q("[data-drop]"); b.disabled = false; b.textContent = COPY.again; b.focus({ preventScroll: true });
        if (TEMP) { temp = HEAT[tries].from; setTimeout(function () { if (!heating) paint(); }, 1200); }
        return;
      }
      won = false;
      q("[data-t2]").textContent = "Diesmal Niete";
      q("[data-prizebox]").hidden = true; q("[data-lose]").hidden = false;
      q("[data-label]").textContent = "Deine E-Mail-Adresse";
      q("[data-submit]").textContent = "Anmelden";
      q("[data-thanks]").textContent = "Wir haben dir eine Mail geschickt. Bestätige deine Adresse, dann bist du dabei.";
    }
    setTimeout(function () { go(2); q("input").focus({ preventScroll: true }); }, wait || 800);
  }

  function go(n) {
    [].forEach.call(root.querySelectorAll(".az-gf__step"), function (s) { s.hidden = +s.getAttribute("data-step") !== n; });
    root.setAttribute("aria-labelledby", "az-gf-t" + n);
    sheet.scrollTop = 0;
  }

  function submit(e) {
    e.preventDefault();
    var input = root.querySelector("input"), err = root.querySelector(".az-gf__err"), btn = e.target.querySelector("button");
    var email = (input.value || "").trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email)) { err.textContent = "Bitte gib eine gültige E-Mail-Adresse ein."; input.focus(); return; }
    btn.disabled = true; btn.textContent = "Wird gesendet";
    var body = { data: { type: "subscription", attributes: {
      custom_source: "Popup Grillfest " + GAME_NAME,
      profile: { data: { type: "profile", attributes: { email: email, properties: {
        "Grillfest Einladung": won, "Popup Ergebnis": result, "Popup Versuche": won ? tries + 1 : TRIES, "Popup Gruppe": "A " + GAME_NAME, "Popup Seite": location.pathname } } } } },
      relationships: { list: { data: { type: "list", id: LIST_ID } } } } };
    fetch("https://a.klaviyo.com/client/subscriptions?company_id=" + COMPANY, {
      method: "POST", headers: { "Content-Type": "application/vnd.api+json", "revision": "2024-10-15" }, body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      ls("azGfDone", String(Date.now()));
      go(3); root.querySelector("[data-done]").focus({ preventScroll: true });
    }).catch(function () {
      err.textContent = "Das hat nicht geklappt. Versuch es bitte nochmal.";
      btn.disabled = false; btn.textContent = won ? "Einladung sichern" : "Anmelden";
    });
  }

  function show() {
    if (!root) build();
    lastFocus = document.activeElement;
    root.hidden = false; document.documentElement.style.overflow = "hidden";
    cancelAnimationFrame(raf); heating = false;
    go(1); layout(); slot = null; ball = null; tries = 0; won = false; temp = HEAT[0].from; result = ""; paint();
    var n = root.querySelector("[data-note]"); n.textContent = ""; n.classList.remove("is-win");
    var b = root.querySelector("[data-drop]"); b.disabled = false; b.textContent = COPY.go;
    root.querySelector("[data-submit]").disabled = false; root.querySelector(".az-gf__err").textContent = "";
    b.focus({ preventScroll: true });
  }
  function hide() {
    cancelAnimationFrame(raf); heating = false;
    root.hidden = true; document.documentElement.style.overflow = "";
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function close() { if (!ls("azGfDone")) ls("azGfClosed", String(Date.now())); hide(); }

  function arm() {
    // Produktseiten sperren Popups die ersten 30 s (Popup-Weiche im Theme): danach alle 5 s nochmal prüfen, höchstens 1 Minute
    var n = 0;
    function check() {
      if (!blocked()) { show(); return; }
      var sticky = typeof window.azNoPopupSticky === "function" && window.azNoPopupSticky();
      if (++n < 12 && !sticky && !ls("azGfDone")) setTimeout(check, 5000);
    }
    setTimeout(check, preview ? 1200 : DELAY);
  }
  window.azGrillfestOpen = show;
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", arm); else arm();
})();
